export default __webpack_public_path__ + "static/flipImg3-b7f4b7fe20d3442802fca9fdf79bc333.webp";